import { registerDecorators as _registerDecorators, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./toolbarButtonMenu.html";
import LightningElementSLDS from 'util/lightningElementSLDS';
import { eventTypes, fireEvent, registerListener, unregisterAllListeners } from 'util/pubsub';
class ToolbarButtonMenu extends LightningElementSLDS {
  constructor() {
    super();
    this.menuItemClickCallback = null;
    this.menuItems = [{
      value: "none"
    }];
    this.label = void 0;
    this.iconName = void 0;
  }
  renderedCallback() {
    console.log("Menu Button rendered: iconName = " + this.iconName);
  }
  handleClick(evt) {
    console.log("handleClick start");
    // $(this.template.querySelector(".menu-content")).toggleClass("dropdown-show");
    console.log("handleClick end");
  }
  menuItemClick(evt) {
    console.log("Menu Item clicked!");
    if (this.menuItemClickCallback) {
      this.menuItemClickCallback(evt);
    }
  }
  handleInit() {
    console.log("handleInit start");
    if (this.callOnInit) {
      console.log("calling callOnInit - start");
      let evt = {
        container: this.template,
        toolbarButton: this
      };
      this.callOnInit(evt);
      console.log("calling callOnInit - end");
      console.log(this.template);
    } else {
      console.log("callOnInit does not have any value");
    }
    console.log("handleInit end");
  }
  getDomElement() {
    return this.template.querySelector("button");
  }
}
_registerDecorators(ToolbarButtonMenu, {
  publicProps: {
    menuItemClickCallback: {
      config: 0
    },
    menuItems: {
      config: 0
    },
    label: {
      config: 0
    },
    iconName: {
      config: 0
    }
  },
  publicMethods: ["handleInit", "getDomElement"]
});
export default _registerComponent(ToolbarButtonMenu, {
  tmpl: _tmpl
});